module.exports = __webpack_public_path__ + "static/media/mainBcg.016d4fcc.jpeg";